import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import InputComponent from "../../../components/Input/input";
import Button from "../../../components/Button/button";
import { MdOutlineViewColumn } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { Label } from "../../../components/Label/styles";
import { IoCloseSharp, IoSearchSharp } from "react-icons/io5";
import { Colors } from "../../../shared/colors/colors";
import {
  ButtonAction,
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../../components/Table/styles";
import { Dropdown } from "react-bootstrap";
import {
  MenuTable,
  MenuTableDivider,
  MenuTableItem,
} from "../../../components/Table/styles";
import { SlOptionsVertical } from "react-icons/sl";
import {
  GrayTitle,
  LoadingGif,
  MainContainer,
  TitleAndButton,
} from "../../../shared/styles/global.styles";
import loadSCGif from "../../../assets/load_SC.gif";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../components/Dropdowns/styles";
import {
  ContainerButtons,
  ContainerFilter,
  InputContainer,
  LoadingContainer,
} from "./styles";
import Pagination from "../../../components/Pagination/pagination";
import ModalDetalhes from "../ModalDetalhesRetorno/modalDetalhesRetorno";
import { GetRetornoDto } from "../../../shared/dtos/Retorno.dto";
import RetornoService from "../../../services/RetornoService";
import { TypeRetorno } from "../../../shared/enum/retorno.enum";
import { formatDateToBR } from "../../../utils/dateUtils/dateUtils";

interface Props {
  editOnly: boolean;
  selectedRetorno: GetRetornoDto | undefined;
  setSelectedRetorno: React.Dispatch<
    React.SetStateAction<GetRetornoDto | undefined>
  >;
}

const ListarRetorno: React.FC<Props> = ({
  editOnly,
  selectedRetorno,
  setSelectedRetorno,
}) => {
  const [filteredRetorno, setFilteredRetorno] = useState<GetRetornoDto[]>([]);
  const [isRequest, setIsRequest] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const [VisibleColumns, setVisibleColumns] = useState<string[]>([]);
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>([]);
  const take = 10;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  const [showModalDetails, setShowModalDetails] = useState<boolean>(false);
  const [selectedRemittance, setSelectedRemittance] = useState<GetRetornoDto>();

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const defaultColumns = [
    "#",
    "N° Sequencial",
    "Nome",
    "Retorno",
    "Status",
    "Carregado por",
    "Total de parcelas",
  ];

  const getAllRemittancesReturn = async (page: number) => {
    setIsRequest(true);
    try {
      await RetornoService.getAll(page, 10).then((response) => {
        const remittancesReturn = response.data;
        const total = response.total;
        setFilteredRetorno(remittancesReturn);
        setTotalPages(Math.ceil(total / 10));
      });
    } catch (error) {
      console.error("Erro ao buscar retornos:", error);
    }
    setIsRequest(false);
  };

  const searchRemittancesReturn = async (page: number) => {
    setIsRequest(true);
    try {
      await RetornoService.getBySearch(searchValue, page, take).then(
        (response) => {
          const Return = response.data;
          const total = response.total;
          setFilteredRetorno(Return);
          setTotalPages(Math.ceil(total / 10));
        }
      );
    } catch (error) {
      console.error("Erro ao buscar retornos:", error);
    }
    setIsRequest(false);
  };

  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(`RetornoVisibleColumns`);
      if (!savedColumns) return setVisibleColumns(defaultColumns);

      const parsedColumns = JSON.parse(savedColumns);
      setVisibleColumns(
        parsedColumns.length > 0 ? parsedColumns : defaultColumns
      );
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const handleColumnToggle = (column: string) => {
    // Se a coluna é padrão, não permite desmarcar
    if (defaultColumns.includes(column)) {
      return;
    }

    setTempVisibleColumns((prev: string[]) => {
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  const handleSearchInput = () => {
    setIsSearch(true);
    if (searchValue.length > 0) {
      setCurrentPage(1);
      searchRemittancesReturn(1);
    } else {
      getAllRemittancesReturn(currentPage);
    }
  };

  const handleClearSearchInput = () => {
    setIsSearch(false);
    setSearchValue("");
    setCurrentPage(1);
    getAllRemittancesReturn(1);
  };

  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value;
    setSearchValue(searchValue);
    if (searchValue === "") {
      handleClearSearchInput();
    }
  };

  const handleApplyColumns = () => {
    setVisibleColumns(tempVisibleColumns); // Atualiza as colunas visíveis
    sessionStorage.setItem(
      `RetornoVisibleColumns`,
      JSON.stringify(tempVisibleColumns)
    ); // Salva no sessionStorage
    setIsOpenMenuCollumn(false); // Fecha o dropdown
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    if (searchValue.length > 0) {
      searchRemittancesReturn(pageNumber);
    } else {
      getAllRemittancesReturn(pageNumber);
    }
  };

  const closeModalDetails = () => {
    setSelectedRemittance(undefined);
    setShowModalDetails(false);
    setSelectedRetorno(undefined);
  };

  const openModalDetails = (data: GetRetornoDto) => {
    setSelectedRemittance(data);
  };

  const cancelEntryRetorno = async (id: number) => {
    try {
      setIsRequest(true);
      Swal.fire({
        title: "Confirmação",
        text: "Tem certeza que deseja cancelar a entrada?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, cancelar!",
        cancelButtonText: "Não, cancelar!",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Aguarde...",
            text: "Cancelando a entrada do retorno...",
            icon: "info",
            showConfirmButton: false,
            allowOutsideClick: false,
            willOpen: () => {
              Swal.showLoading();
            },
          });
          const response = await RetornoService.cancelEntryRetorno(id);
          if (response.success) {
            Swal.fire({
              title: "Sucesso",
              text: response.message,
              icon: "success",
              allowOutsideClick: false,
            });
          } else {
            Swal.fire({
              title: "Erro",
              text: response.message,
              icon: "error",
              allowOutsideClick: false,
            });
          }
        }
      });
    } catch (error) {
      console.error("Erro ao cancelar a entrada:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao cancelar a entrada. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    } finally {
      setIsRequest(false);
      getAllRemittancesReturn(1);
    }
  };

  const downloadRemittanceReturn = async (name: string) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}remessas/retorno/${name}`
      );
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Erro ao fazer download do retorno:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao fazer download do retorno. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  useEffect(() => {
    loadVisibleColumns();
    getAllRemittancesReturn(1);
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    if (selectedRetorno) {
      openModalDetails(selectedRetorno);
      getAllRemittancesReturn(1);
      setCurrentPage(1);
    }
  }, [selectedRetorno]);

  useEffect(() => {
    if (selectedRemittance) {
      setShowModalDetails(true);
    }
  }, [selectedRemittance]);

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(VisibleColumns); // Inicializa o estado temporário com as colunas visíveis atuais
    }
  }, [isOpenMenuCollumn, VisibleColumns]);

  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  return (
    <MainContainer>
      <TitleAndButton>
        <GrayTitle>Retornos Carregados</GrayTitle>
      </TitleAndButton>
      <InputContainer>
        {/* Label para o campo */}
        <Label htmlFor="remessa-sequencial-search" id="pesquisa-sequencial">
          Pesquisar por id, nome do arquivo ou numero de sequencial:
        </Label>
        <ContainerFilter>
          <InputComponent
            type="text"
            id="search"
            value={searchValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value.replace(".", ",");
              handleSearchChange({
                ...e,
                target: { ...e.target, value },
              });
            }}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Impede o comportamento padrão de submissão do formulário
                handleSearchInput();
              }
            }}
            placeholder="Busque pelo id, nome ou número sequencial"
            maxLength={45}
            color="black"
            width={399}
            iconRight={
              isSearch ? (
                <IoCloseSharp size={24} color={Colors.inputIcon} />
              ) : (
                <IoSearchSharp size={24} color={Colors.inputIcon} />
              )
            }
            onIconRightClick={() => {
              isSearch ? handleClearSearchInput() : handleSearchInput();
            }}
            disabled={isRequest}
          />

          <ContainerButtons>
            <Button
              schemaButton="out-primary"
              action={() => setIsOpenMenuCollumn(!isOpenMenuCollumn)}
              icon={
                <MdOutlineViewColumn size={20} style={{ marginRight: "8px" }} />
              }
            >
              Selecionar colunas
            </Button>

            <Dropdown.Menu ref={dropdownMenuRef} show={isOpenMenuCollumn}>
              <DropdownScroll>
                {[
                  "#",
                  "N° Sequencial",
                  "Nome",
                  "Retorno",
                  "Carregado por",
                  "Carregado em",
                  "Total de parcelas",
                ].map((column, index, array) => (
                  <React.Fragment key={column}>
                    {!defaultColumns.includes(column) && (
                      <Dropdown.Item
                        key={index}
                        eventKey="1"
                        onClick={() => handleColumnToggle(column)}
                        style={{ color: Colors.primary }}
                      >
                        <img
                          src={
                            tempVisibleColumns.includes(column)
                              ? "/images/checkbox-marked.svg"
                              : "/images/checkbox-blank-outline.svg"
                          }
                          alt={
                            tempVisibleColumns.includes(column)
                              ? defaultColumns.includes(column)
                                ? "Bloqueado"
                                : "Selecionado"
                              : "Não selecionado"
                          }
                          className="checkbox-image"
                        />
                        <label>{column}</label>
                        {array
                          .filter((col) => !defaultColumns.includes(col))
                          .indexOf(column) <
                          array.filter((col) => !defaultColumns.includes(col))
                            .length -
                            1 && <DropdownDivider />}
                      </Dropdown.Item>
                    )}
                  </React.Fragment>
                ))}
              </DropdownScroll>
              {JSON.stringify(tempVisibleColumns.sort()) !==
                JSON.stringify(VisibleColumns.sort()) && (
                <Dropdown.Item>
                  <MenuTableDivider />
                  <Button
                    schemaButton="with-margin"
                    action={handleApplyColumns} // Aplica as mudanças ao clicar
                  >
                    Aplicar
                  </Button>
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </ContainerButtons>
        </ContainerFilter>
      </InputContainer>
      <TableContainer>
        {isRequest ? (
          <LoadingContainer>
            <LoadingGif src={loadSCGif} alt="Carregando..." />
          </LoadingContainer>
        ) : (
          <Table id="-tabela" style={{ minHeight: "175px" }}>
            <TableHead>
              <TableRow>
                {VisibleColumns.includes("#") && <TableHeader>#</TableHeader>}
                {VisibleColumns.includes("N° Sequencial") && (
                  <TableHeader>N° Sequencial</TableHeader>
                )}
                {VisibleColumns.includes("Nome") && (
                  <TableHeader>Nome</TableHeader>
                )}
                {VisibleColumns.includes("Retorno") && (
                  <TableHeader>Retorno de</TableHeader>
                )}
                {VisibleColumns.includes("Status") && (
                  <TableHeader>Status</TableHeader>
                )}
                {VisibleColumns.includes("Carregado por") && (
                  <TableHeader>Carregado por</TableHeader>
                )}
                {VisibleColumns.includes("Carregado em") && (
                  <TableHeader>Carregado em</TableHeader>
                )}
                {VisibleColumns.includes("Total de parcelas") && (
                  <TableHeader>Total de parcelas</TableHeader>
                )}
                <TableHeader>Ações</TableHeader>
              </TableRow>
            </TableHead>
            <tbody>
              {filteredRetorno.length > 0 ? (
                filteredRetorno.map((Retorno) => (
                  <TableRow key={Retorno.id}>
                    {VisibleColumns.includes("#") && (
                      <TableData>{Retorno.id}</TableData>
                    )}
                    {VisibleColumns.includes("N° Sequencial") && (
                      <TableData>{Retorno.sequenceNumber}</TableData>
                    )}
                    {VisibleColumns.includes("Nome") && (
                      <TableData>{Retorno.fileName}</TableData>
                    )}
                    {VisibleColumns.includes("Retorno") && (
                      <TableData>
                        {Retorno.localPagamento?.descricao || "-"}
                      </TableData>
                    )}
                    {VisibleColumns.includes("Status") && (
                      <TableData>{Retorno.status}</TableData>
                    )}
                    {VisibleColumns.includes("Carregado por") && (
                      <TableData>{Retorno.user.name}</TableData>
                    )}
                    {VisibleColumns.includes("Carregado em") && (
                      <TableData>
                        {Retorno.createAt
                          ? formatDateToBR(Retorno.createAt.toString())
                          : "-- / -- / ----"}
                      </TableData>
                    )}
                    {VisibleColumns.includes("Total de parcelas") && (
                      <TableData>{Retorno.totalFinancialRecord || 0}</TableData>
                    )}
                    <TableData
                      style={{
                        position: "relative",
                        overflow: "visible",
                      }}
                    >
                      <ButtonAction
                        onClick={() => toggleDropdown(Retorno.id)}
                        style={{ marginLeft: "auto" }}
                      >
                        {isOpen === Retorno.id ? (
                          <IoMdClose
                            cursor={"pointer"}
                            size={20}
                            style={{ color: Colors.primary }}
                          />
                        ) : (
                          <SlOptionsVertical
                            cursor={"pointer"}
                            size={20}
                            style={{ color: Colors.primary }}
                          />
                        )}
                      </ButtonAction>
                      <MenuTable
                        show={isOpen === Retorno.id}
                        align="start"
                        onHide={() => setIsOpen(null)}
                        isLastRows={
                          filteredRetorno.length > 0 &&
                          filteredRetorno.indexOf(Retorno) >=
                            filteredRetorno.length -
                              Math.ceil(filteredRetorno.length / 2)
                        }
                        ref={(el: HTMLDivElement | null) => {
                          // Armazena a referência no mapa usando o ID do registro como chave
                          menuRefsMap.current.set(Retorno.id, el);
                        }}
                      >
                        <MenuTableItem
                          onClick={() => {
                            downloadRemittanceReturn(Retorno.fileName);
                            setIsOpen(null);
                          }}
                        >
                          Download do arquivo de retorno
                        </MenuTableItem>
                        <MenuTableDivider />
                        {Retorno.totalFinancialRecord !== undefined &&
                          Retorno.totalFinancialRecord > 0 && (
                            <>
                              <MenuTableItem
                                onClick={() => {
                                  cancelEntryRetorno(Retorno.id);
                                  setIsOpen(null);
                                }}
                              >
                                Cancelar entrada
                              </MenuTableItem>
                              <MenuTableDivider />
                            </>
                          )}
                        <MenuTableItem
                          onClick={() => {
                            openModalDetails(Retorno);
                            setIsOpen(null);
                          }}
                        >
                          Detalhes
                        </MenuTableItem>
                      </MenuTable>
                    </TableData>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableData
                    colSpan={VisibleColumns.length + 1}
                    className="text-center text-muted"
                  >
                    Nenhum retorno encontrado.
                  </TableData>
                </TableRow>
              )}
            </tbody>
          </Table>
        )}
      </TableContainer>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      {selectedRemittance && showModalDetails && (
        <ModalDetalhes
          show={showModalDetails}
          onClose={closeModalDetails}
          numeroSequencial={selectedRemittance?.sequenceNumber.toString()}
          tipoRemessa={selectedRemittance?.localPagamento?.descricao || "-"}
          id={selectedRemittance?.id}
        />
      )}
    </MainContainer>
  );
};

export default ListarRetorno;
